let csvw_url = 'https://www.csvw.com';
export default {
  // kv
  workspace: {},
  // 车型素材
  workspace2: {
    neishi: Array.from({
      length: 1
    }).map((item, i) => {
      return require(`../../assets/passatp/imgs/neishi/${i+1}.jpg`)
    }),
    waiguan: Array.from({
      length: 8
    }).map((item, i) => {
      return require(`../../assets/passatp/imgs/waiguan/${i+1}.jpg`)
    }),
    qita: Array.from({
      length: 3
    }).map((item, i) => {
      return require(`../../assets/passatp/imgs/qita/${i+1}.jpg`)
    }),
    shipin: [
      require("../../assets/passatp/imgs/shipin/1.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202106/151709349S84.mp4",
    ],
  },
  // 新闻稿
  workspace3: {
    list: [{
        title: '17.99万-25.09万',
        title1: '新帕萨特家族“双前脸”造型焕新上市',
        subtitle: '8月26日， B级轿车新帕萨特正式上市，首度推出“双前脸”造型，进一步满足不同人群的个性化需求。新帕萨特提供280TSI, 330TSI及380TSI 三种动力总成，建议零售价为17.99万元—25.09万元；新帕萨特PHEV提供插电混动商务版、精英版及豪华版三款车型，建议零售价为21.39万元—23.89万元。',
        imgurl: require("../../assets/passatp/imgs/xinwen/1.png"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/xinwen/1.png"),
        url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3133'
      },
    ]
  },
  // 大咖点评
  workspace4: {
    list: [{
        title: require("../../assets/passatp/imgs/logo/1.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/1.png"),
        subtitle: '新帕萨特PHEV搭载1.4T发动机和电机组成的插电式混动系统，其中发动机最大功率150马力，电动机最大功率85千瓦，系统综合功率为155千瓦，系统综合扭矩为400牛·米。',
        imgurl: require("../../assets/passatp/imgs/daka/1.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/1.jpg"),
        url: 'https://www.autohome.com.cn/news/202107/1178034.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/2.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/2.png"),
        subtitle: '新帕萨特PHEV采用14T发动机+电动机组成的插电混合动力系统。纯电模式下，续航达到63公里，最快3.5小时就能充满电。',
        imgurl: require("../../assets/passatp/imgs/daka/2.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/2.jpg"),
        url: 'https://newcar.xcar.com.cn/202107/news_2060816_1.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/3.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/3.png"),
        subtitle: '新帕萨特PHEV采用了大众最新的设计语言，前中网上还有“PHEV”标识，用来识别身份，至于充电口则位于Logo右侧。',
        imgurl: require("../../assets/passatp/imgs/daka/3.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/3.jpg"),
        url: 'http://news.yiche.com/danchedaogou/20210717/0015017031.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/4.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/4.png"),
        subtitle: '新帕萨特PHEV搭载了14T发动机+电动机组成的插电混合动力系统。',
        imgurl: require("../../assets/passatp/imgs/daka/4.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/4.jpg"),
        url: 'https://new.qq.com/omn/20210717/20210717A09IHN00.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/5.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/5.png"),
        subtitle: '新帕萨特PHEV延续430PHEV尾标，其动力系统由1.4TSI发动机与最大功率85千瓦的前置单电机构成整套动力系统。',
        imgurl: require("../../assets/passatp/imgs/daka/5.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/5.jpg"),
        url: 'https://mini.eastday.com/nsa/210718004425293228936.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/6.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/6.png"),
        subtitle: '新帕萨特PHEV使用1.4T发动机搭配85千瓦的电动机。在续航方面，其NEDC续航里程为63公里。',
        imgurl: require("../../assets/passatp/imgs/daka/6.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/6.jpg"),
        url: 'https://hj.pcauto.com.cn/article/871147'
      },
      {
        title: require("../../assets/passatp/imgs/logo/7.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/7.png"),
        subtitle: '新帕萨特PHEV提供基于1.4T发动机和电机组成的动力系统。',
        imgurl: require("../../assets/passatp/imgs/daka/7.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/7.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/9077076'
      },
      {
        title: require("../../assets/passatp/imgs/logo/8.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/8.png"),
        subtitle: '新帕萨特PHEV前格栅为镀铬点阵式设计，充电口也隐藏在车标之后。此外格栅左侧、前翼子板等处还加入了“PHEV”字样表明新能源身份。',
        imgurl: require("../../assets/passatp/imgs/daka/8.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/8.jpg"),
        url: 'https://cheshihao.cheshi.com/news/539457.html'
      },
      {
        title: require("../../assets/passatp/imgs/logo/9.png"),
        titleMobile: require("../../assets/passatp/imgs/logo/9.png"),
        subtitle: '新帕萨特PHEV由1.4T发动机和电机组成，电动机最大功率116马力，整套动力系统最大功率211马力，系统峰值扭矩400牛·米，而三元锂电池的纯电续航约为63公里。',
        imgurl: require("../../assets/passatp/imgs/daka/9.jpg"),
        imgurlMobile: require("../../assets/passatp/imgsMobile/daka/9.jpg"),
        url: 'https://www.qctt.cn/news/1052398'
      },
    ]
  },
  // 媒体试驾
  workspace5: {
    
  },
  // 现场直击(作废板块)
  // 现场直击
  workspace6: {
    
  }
}